/**
 * x-header.js
 * Behavior for sections/x-header.liquid: sticky scroll shadow, search panel
 * toggle, mobile drawer open/close. Section id comes from this script tag's
 * [data-section-id] so the section file stays free of inline JS.
 */
(function () {
  var scriptEl = document.currentScript;
  var sid = scriptEl ? scriptEl.getAttribute('data-section-id') : '';
  var header = document.getElementById('XHeader-' + sid);
  if (!header || header.dataset.xHeaderBound) return;
  header.dataset.xHeaderBound = 'true';

  /* sticky shadow on scroll. This theme scrolls `.page-wrapper` (not the
     document) at >=990px viewports ("squeeze layout") -- document/window
     never fire a 'scroll' event there, so this has to target whichever
     element the theme itself actually scrolls at the current breakpoint. */
  var squeezeQuery = window.matchMedia('(min-width: 990px)');
  var scrollTarget = null;

  function getScrollTarget() {
    if (squeezeQuery.matches) {
      return document.querySelector('.page-wrapper') || document;
    }
    return document;
  }

  function getScrollTopValue(target) {
    if (target === document) {
      return (document.scrollingElement || document.documentElement).scrollTop;
    }
    return target.scrollTop;
  }

  function onScroll() {
    if (getScrollTopValue(scrollTarget) > 8) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  function bindScrollTarget() {
    if (scrollTarget) scrollTarget.removeEventListener('scroll', onScroll);
    scrollTarget = getScrollTarget();
    scrollTarget.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  bindScrollTarget();
  squeezeQuery.addEventListener('change', bindScrollTarget);

  /* search panel toggle */
  var searchBtn = document.getElementById('XHeaderSearchBtn-' + sid);
  var searchPanel = document.getElementById('XHeaderSearchPanel-' + sid);
  if (searchBtn && searchPanel) {
    searchBtn.addEventListener('click', function () {
      var isOpen = searchPanel.classList.toggle('is-open');
      searchBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        window.setTimeout(function () {
          var input = searchPanel.querySelector('input[type="text"]');
          if (input) input.focus();
        }, 150);
      }
    });
  }

  /* mobile drawer */
  var hamburgerBtn = document.getElementById('XHeaderHamburger-' + sid);
  var drawerCloseBtn = document.getElementById('XHeaderDrawerClose-' + sid);
  var drawer = document.getElementById('XHeaderDrawer-' + sid);
  var overlay = document.getElementById('XHeaderOverlay-' + sid);

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    hamburgerBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    hamburgerBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (hamburgerBtn && drawer && overlay) {
    hamburgerBtn.addEventListener('click', openDrawer);
    drawerCloseBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }
})();
